import React from "react";
import style from "./index.module.css";

const Table = ({ table }: ComponentPropsType) => {
  return (
    <table className={style.table}>
      <tbody>
        {table.map((row, index) => (
          <tr key={index}>
            {row.map((col, index) => (
              <td key={index}>{col}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Table;

export type TableType = string[][];

type ComponentPropsType = {
  table: TableType;
};
